var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form",
      attrs: { "lazy-validation": "" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        }
      },
      model: {
        value: _vm.valid,
        callback: function($$v) {
          _vm.valid = $$v
        },
        expression: "valid"
      }
    },
    [
      _c(
        "v-container",
        { attrs: { "grid-list-md": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.paises,
                      "item-text": "pais",
                      "item-value": function(val) {
                        return parseInt(val.id)
                      },
                      label: "País de nacimiento",
                      rules: _vm.$validate(["required"]),
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.pais_nacimiento,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "pais_nacimiento", $$v)
                      },
                      expression: "form.pais_nacimiento"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.departamentos,
                      "item-text": "valor",
                      "item-value": function(val) {
                        return parseInt(val.id)
                      },
                      disabled:
                        _vm.form.pais_nacimiento != 120 || this.estado == 0,
                      rules:
                        _vm.form.pais_nacimiento == 120
                          ? _vm.$validate(["required"])
                          : [],
                      label: "Departamento de nacimiento"
                    },
                    model: {
                      value: _vm.form.id_parametro_departamento,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "id_parametro_departamento", $$v)
                      },
                      expression: "form.id_parametro_departamento"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.paises,
                      "item-text": "pais",
                      "item-value": "id",
                      label: "Nacionalidad",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.nacionalidad,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "nacionalidad", $$v)
                      },
                      expression: "form.nacionalidad"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md3: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.paises,
                      "item-text": "pais",
                      "item-value": function(val) {
                        return parseInt(val.id)
                      },
                      label: "Pais de Residencia",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.pais_residencia,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "pais_residencia", $$v)
                      },
                      expression: "form.pais_residencia"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs3: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.ciudades,
                      "item-text": "ciudad",
                      "item-value": function(val) {
                        return parseInt(val.id)
                      },
                      label: "Ciudad de Residencia",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.ciudad_residencia,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "ciudad_residencia", $$v)
                      },
                      expression: "form.ciudad_residencia"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md3: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.generos,
                      "item-text": "valor",
                      "item-value": function(val) {
                        return parseInt(val.id)
                      },
                      label: "Genero",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.id_genero,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "id_genero", $$v)
                      },
                      expression: "form.id_genero"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md3: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      rules: _vm.$validate(["required"]),
                      required: "",
                      label: "Fecha de nacimiento",
                      type: "date",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.fecha_nacimiento,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "fecha_nacimiento", $$v)
                      },
                      expression: "form.fecha_nacimiento"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md2: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.estado_civil,
                      "item-text": "valor",
                      "item-value": function(val) {
                        return parseInt(val.id)
                      },
                      label: "Estado Civil",
                      rules: _vm.$validate(["required"]),
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.id_parametro_estado_civil,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "id_parametro_estado_civil", $$v)
                      },
                      expression: "form.id_parametro_estado_civil"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-text-field", {
                    ref: "zona",
                    staticClass: "mayuscula",
                    attrs: {
                      rules: _vm.$validate(["required"]),
                      label: " Zona",
                      required: "",
                      placeholder: "Zona",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.zona,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "zona", $$v)
                      },
                      expression: "form.zona"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-text-field", {
                    ref: "direccion",
                    staticClass: "mayuscula",
                    attrs: {
                      rules: _vm.$validate(["required"]),
                      label: "Calle o Avenida/ Nro. de vivienda",
                      required: "",
                      placeholder: "Dirección",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.direccion,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "direccion", $$v)
                      },
                      expression: "form.direccion"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md2: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      type: "number",
                      label: "Teléfono Domicilio",
                      required: "",
                      rules: [
                        function(v) {
                          if (v < 0) {
                            return "Los numeros no pueden ser negativos"
                          }
                          return true
                        }
                      ],
                      maxlength: "25",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.telefono_domicilio,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "telefono_domicilio", $$v)
                      },
                      expression: "form.telefono_domicilio"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md3: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      type: "number",
                      label: "Teléfono Alternativo",
                      required: "",
                      rules: [
                        function(v) {
                          return !!v || "Este campo es obligatorio"
                        },
                        function(v) {
                          if (v < 0) {
                            return "Los numeros no pueden ser negativos"
                          }
                          return true
                        }
                      ],
                      maxlength: "25",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.telefono_alternativo,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "telefono_alternativo", $$v)
                      },
                      expression: "form.telefono_alternativo"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md3: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      type: "number",
                      label: "Celular",
                      required: "",
                      rules: [
                        function(v) {
                          if (v < 0) {
                            return "Los numeros no pueden ser negativos"
                          }
                          return true
                        }
                      ],
                      maxlength: "25",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.celular,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "celular", $$v)
                      },
                      expression: "form.celular"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md3: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Correo Electrónico Personal",
                      required: "",
                      rules: _vm.$validate(["email", "required"]),
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.correo_personal,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "correo_personal", $$v)
                      },
                      expression: "form.correo_personal"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md3: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Cuenta Facebook",
                      required: "",
                      rules: _vm.$validate(["required"]),
                      maxlength: "100",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.cuenta_facebook,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "cuenta_facebook", $$v)
                      },
                      expression: "form.cuenta_facebook"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md3: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Cuenta Twitter",
                      required: "",
                      maxlength: "50",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.cuenta_twitter,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "cuenta_twitter", $$v)
                      },
                      expression: "form.cuenta_twitter"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md3: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.tipo_sangre,
                      "item-text": "valor",
                      "item-value": function(val) {
                        return parseInt(val.id)
                      },
                      label: "Grupo Sanguíneo",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.id_parametro_grupo_sanguineo,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "id_parametro_grupo_sanguineo", $$v)
                      },
                      expression: "form.id_parametro_grupo_sanguineo"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "grey lighten-2 text--info" },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c("v-flex", { staticClass: "px-3" }, [
                        _c("strong", [_vm._v(" Documentos personales ")])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.entidad_previsora,
                      "item-text": "valor",
                      "item-value": function(val) {
                        return parseInt(val.id)
                      },
                      rules: _vm.$validate(["required"]),
                      label: "Entidad previsora",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.id_parametro_entidad_previsora,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.form,
                          "id_parametro_entidad_previsora",
                          $$v
                        )
                      },
                      expression: "form.id_parametro_entidad_previsora"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Nro. NUA/CUA",
                      required: "",
                      rules: _vm.$validate(["required"]),
                      maxlength: "25",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.nro_nua,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "nro_nua", $$v)
                      },
                      expression: "form.nro_nua"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.tipo_fondo_pensiones,
                      "item-text": "valor",
                      "item-value": function(val) {
                        return parseInt(val.id)
                      },
                      label: "Tipo de fondo de pensiones",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.id_parametro_tipo_fondo,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "id_parametro_tipo_fondo", $$v)
                      },
                      expression: "form.id_parametro_tipo_fondo"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md6: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mayuscula",
                    attrs: {
                      label: "Nombre de Banco",
                      required: "",
                      rules: _vm.$validate(["required"]),
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.banco,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "banco", $$v)
                      },
                      expression: "form.banco"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md6: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      type: "number",
                      label: "Nro. de cuenta bancaria",
                      required: "",
                      rules: _vm.$validate(["required"]),
                      maxlength: "20",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.nro_cuenta_bancaria,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "nro_cuenta_bancaria", $$v)
                      },
                      expression: "form.nro_cuenta_bancaria"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mayuscula",
                    attrs: {
                      label: "Colegio de profesional al que pertenece",
                      maxlength: "50",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.colegio_profesional,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "colegio_profesional", $$v)
                      },
                      expression: "form.colegio_profesional"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "mayuscula",
                    attrs: {
                      label: "Nro. de registro profesional (RP)",
                      maxlength: "50",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.nro_registro_profesional,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "nro_registro_profesional", $$v)
                      },
                      expression: "form.nro_registro_profesional"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Fecha registro profesional",
                      type: "date",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.fecha_reg_profesional,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "fecha_reg_profesional", $$v)
                      },
                      expression: "form.fecha_reg_profesional"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      type: "number",
                      label: "Nro. de libreta de servicio militar",
                      required: "",
                      maxlength: "20",
                      rules: [
                        function(v) {
                          if (v < 0) {
                            return "El campo no puede ser negativo."
                          }
                          if (v >= 10000000000000000000) {
                            return "No puede ingresar un número tan grande."
                          }
                          return true
                          return true
                        }
                      ],
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.libreta_serv_militar,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "libreta_serv_militar", $$v)
                      },
                      expression: "form.libreta_serv_militar"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md4: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.anios,
                      "item-text": "anio",
                      "item-value": "anio",
                      label: "Año",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.anio_serv_militar,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "anio_serv_militar", $$v)
                      },
                      expression: "form.anio_serv_militar"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md12: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Categoría de licencia",
                      required: "",
                      maxlength: "30",
                      disabled: this.estado == 0
                    },
                    model: {
                      value: _vm.form.nro_licencia_conducir,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "nro_licencia_conducir", $$v)
                      },
                      expression: "form.nro_licencia_conducir"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("v-flex", { attrs: { md3: "" } }, [
                _c("div", { attrs: { id: "preview" } }, [
                  _vm.img_url
                    ? _c("img", {
                        attrs: { src: _vm.img_url, height: "150", width: "150" }
                      })
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { md12: "" } },
                [
                  _c("input", {
                    ref: "file",
                    attrs: { type: "file", accept: "image/*" },
                    on: { change: _vm.cargarImagen }
                  }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  this.img_error
                    ? _c("v-flex", { attrs: { xs3: "" } }, [
                        _c(
                          "small",
                          { staticClass: "error--text text-required" },
                          [_vm._v(_vm._s(this.img_error_message))]
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c("small", { staticClass: "error--text text-required" }, [
            _vm._v("* Los campos son obligatorios")
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { md12: "", xs12: "" } },
            [
              _vm.estado == 1
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        type: "submit",
                        disabled: !_vm.valid,
                        loading: _vm.loading
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
                      _vm._v(" " + _vm._s(_vm.$t("common.save")) + "\n    ")
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3401b06e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3401b06e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ficha_personal/components/DatosPersonalesBasicos.vue
// module id = null
// module chunks = 